module.exports = __webpack_public_path__ + "static/media/logo-ufg.44bc8091.png";